const hac = require('./horizontal-accordion.js');
hac();
